import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useEffectEvent } from 'react';

export interface ToastMessage {
  /** Nowe id = nowy komunikat (i nowe odliczanie). */
  id: number;
  text: string;
}

export const toast = (text: string): ToastMessage => ({ id: Date.now(), text });

/** Krótki komunikat nad dolną nawigacją; znika sam. */
export function Toast({ message, onDismiss, duration = 4000 }: { message: ToastMessage | null; onDismiss: () => void; duration?: number }) {
  const dismiss = useEffectEvent(onDismiss);
  const id = message?.id;
  useEffect(() => {
    if (id === undefined) return;
    const t = window.setTimeout(dismiss, duration);
    return () => window.clearTimeout(t);
  }, [id, duration]);

  return (
    <div
      className="pointer-events-none fixed inset-x-0 z-40 mx-auto max-w-xl px-3"
      style={{ bottom: 'calc(env(safe-area-inset-bottom, 0px) + 4.5rem)' }}
      role="status"
      aria-live="polite"
    >
      <AnimatePresence>
        {message && (
          <motion.div
            key={message.id}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 8 }}
            transition={{ duration: 0.15 }}
            onClick={onDismiss}
            className="pointer-events-auto flex min-h-12 items-center rounded-xl bg-stone-900 px-4 py-2 text-white shadow-lg dark:bg-stone-100 dark:text-stone-900"
          >
            {message.text}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
